module.exports = __webpack_public_path__ + "img/jsszbtbggfwpt.0d44d367.png";